import {
  deleteDonorAccount,
  donorPasswordChange,
  getCurrentDonor,
  logout,
} from "appState/auth/authSlice";
import { TKIconSpinner } from "assets/images/svgs";
import DonateCard from "features/HomePage/components/DonateCard";
import { useFormik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import InputField from "shared/InputField";
import { changePasswordValidationSchema } from "validation/ngo/changePasswordSchema";

const DonorAccount = () => {
  const { isLoading } = useSelector((state) => state.auth);
  const { projects } = useSelector((state) => state.project);
  const slicedDonateArr = projects?.slice(0, 3);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: changePasswordValidationSchema,
    onSubmit: (values) => {
      const body = {
        oldPassword: values.oldPassword,
        password: values.password,
      };
      dispatch(donorPasswordChange(body)).then((data) => {
        if (data?.payload?.status === 200) {
          toast.success("Donor password updated!");
          dispatch(getCurrentDonor());
        }
      });
    },
  });

  return (
    <div className="flex flex-col gap-6 my-4 items-start">
      <div className="px-12 py-6 bg-white border border-[#838383]">
        <p className="text-[16px] text-[#213874]">Monthly Donations</p>
        {false ? (
          <div className="mt-5 flex gap-6 justify-center max-md:flex-wrap">
            {slicedDonateArr?.map((donateCard) => (
              <div key={donateCard.id}>
                <DonateCard
                  id={donateCard.id}
                  cardImage={donateCard.cardImage}
                  title={donateCard.title}
                  body={donateCard.body}
                  amountRaised={donateCard.amountRaised}
                  targetAmount={donateCard.targetAmount}
                  bgColor={donateCard.theme}
                  width={donateCard.width}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-5">
            <p className="text-[#7A7A7A]">
              You currently do not have a monthly donation. If you would like to
              support a project on a monthly basis, first find a project, then
              choose the "monthly" option at checkout.
            </p>
            <div className="flex justify-center items-center">
              <Link to="/projects">
                <button
                  type="button"
                  className="bg-[#213874] my-2 hover:bg-[#11224d] text-white py-2 px-8 rounded-3xl"
                >
                  Find a Project
                </button>
              </Link>
            </div>
          </div>
        )}
      </div>
      <div className="px-12 py-6 bg-white border border-[#838383]">
        <p className="text-[16px] text-[#213874]">Recent Donations</p>
        {false ? (
          <div className="mt-5 flex gap-6 justify-center max-md:flex-wrap">
            {slicedDonateArr?.map((donateCard) => (
              <div key={donateCard.id}>
                <DonateCard
                  id={donateCard.id}
                  cardImage={donateCard.cardImage}
                  title={donateCard.title}
                  body={donateCard.body}
                  amountRaised={donateCard.amountRaised}
                  targetAmount={donateCard.targetAmount}
                  bgColor={donateCard.theme}
                  width={donateCard.width}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-5">
            <p className="text-[#7A7A7A]">
              You have not donated to a project yet. If you would like to
              support a project, explore our projects by theme and location, and
              find the one that speaks to your heart.
            </p>
            <div className="flex justify-center items-center">
              <Link to="/projects">
                <button
                  type="button"
                  className="bg-[#213874] my-2 hover:bg-[#11224d] text-white py-2 px-8 rounded-3xl"
                >
                  Find a Project
                </button>
              </Link>
            </div>
          </div>
        )}
      </div>
      <div className="px-12 py-6 bg-white border border-[#838383]">
        <p className="text-[16px] text-[#213874]">Saved Payment Method</p>
        {false ? (
          <div className="mt-5 flex gap-6 justify-center max-md:flex-wrap">
            {slicedDonateArr?.map((donateCard) => (
              <div key={donateCard.id}>
                <DonateCard
                  id={donateCard.id}
                  cardImage={donateCard.cardImage}
                  title={donateCard.title}
                  body={donateCard.body}
                  amountRaised={donateCard.amountRaised}
                  targetAmount={donateCard.targetAmount}
                  bgColor={donateCard.theme}
                  width={donateCard.width}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-5">
            <p className="text-[#7A7A7A]">
              You currently do not have a saved payment method. To save a credit
              card for faster checkout, find a project to which you'd like to
              donate, and at checkout choose "Remember this card" below your
              payment information.
            </p>
            <div className="flex justify-center items-center">
              <Link to="/projects">
                <button
                  type="button"
                  className="bg-[#213874] my-2 hover:bg-[#11224d] text-white py-2 px-8 rounded-3xl"
                >
                  Find a Project
                </button>
              </Link>
            </div>
          </div>
        )}
      </div>
      <div className="w-full px-12 py-6 bg-white border border-[#838383]">
        <p className="text-[16px] text-[#213874]">Email Settings</p>
        <div className="mt-5 w-full">
          <div className="flex flex-wrap gap-3 mt-2 justify-start items-center">
            <button
              type="button"
              className="bg-[#213874] my-2 hover:bg-[#11224d] text-white py-2 px-8 rounded-3xl"
            >
              Edit email preference
            </button>
            <button
              type="button"
              className="my-2 hover:bg-[#e7e8ed] text-[#213874] py-2 px-8 rounded-3xl border border-[#213874]"
            >
              Unsubscribe
            </button>
          </div>
        </div>
      </div>
      <div className="w-full px-12 py-6 bg-white border border-[#838383]">
        <form onSubmit={formik.handleSubmit}>
          <p className="text-[16px] text-[#213874]">Reset Password</p>
          <div className="mt-5 w-full">
            <p className="text-[#7A7A7A]">
              To change your password below, simply enter your new password
              twice. Password must be between 8-20 characters long.
            </p>
            <div className="w-full flex flex-wrap items-center my-4 gap-3">
              <div className="w-1/4 flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  Current Password
                </label>
                <div className="w-full">
                  <InputField
                    className="!bg-[#F6F6F6F6] !min-h-[35px] !rounded-3xl placeholder:text-[#212121] "
                    type="password"
                    name="oldPassword"
                    placeholder="*********"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.oldPassword}
                  />
                  {formik.touched.oldPassword && formik.errors.oldPassword ? (
                    <p className="text-red-500 text-xs mt-[8px]">
                      {formik.errors.oldPassword}
                    </p>
                  ) : null}
                </div>
              </div>
              <div className="w-1/4 flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  New Password
                </label>
                <div className="w-full">
                  <InputField
                    className="!bg-[#F6F6F6F6] !min-h-[35px] !rounded-3xl placeholder:text-[#212121] "
                    type="password"
                    name="password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                  />
                  {formik.touched.password && formik.errors.password ? (
                    <p className="text-red-500 text-xs mt-[8px]">
                      {formik.errors.password}
                    </p>
                  ) : null}
                </div>
              </div>
              <div className="w-1/4 flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  Confirm Password
                </label>
                <div className="w-full">
                  <InputField
                    className="!bg-[#F6F6F6F6] !min-h-[35px] !rounded-3xl placeholder:text-[#212121] "
                    type="password"
                    name="confirmPassword"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.confirmPassword}
                  />
                  {formik.touched.confirmPassword &&
                  formik.errors.confirmPassword ? (
                    <p className="text-red-500 text-xs mt-[8px]">
                      {formik.errors.confirmPassword}
                    </p>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="w-fit flex flex-col">
              <button
                type="submit"
                className="py-3 px-8 border flex items-center text-white rounded-3xl bg-[#213874] w-[100px] h-[50px]"
              >
                {isLoading ? <TKIconSpinner /> : "Save"}
              </button>
            </div>
          </div>
        </form>
      </div>
      <div className="w-full flex justify-end items-end">
        <p
          onClick={() => {
            dispatch(deleteDonorAccount()).then((data) => {
              const { payload } = data;
              if (payload?.status === 200) {
                dispatch(logout());
                navigate("/auth/donor/login");
              }
            });
          }}
          className="cursor-pointer py-3 px-8 border hover:bg-[#f4dfdf] text-[#C81818] border-[#C81818]"
        >
          Delete my account
        </p>
      </div>
    </div>
  );
};

export default DonorAccount;
